import { TextField, Autocomplete, Chip } from '@mui/material'

interface TagInputFormProps {
  tags: string[]
  setTags: (tags: string[]) => void
}

const TagsInputForm = (props: TagInputFormProps) => {
  const { tags, setTags } = props
  return (
    <Autocomplete
      multiple
      id="tags"
      freeSolo
      value={tags}
      onChange={(event, newValue) => {
        setTags(newValue)
      }}
      options={[]}
      renderTags={(value: string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip variant="outlined" label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          multiline
          inputProps={{
            ...params.inputProps,
            className: '',
            style: {
              display: 'flex',
              padding: '10px',
            },
          }}
          rows={2}
          label="แท็ก"
          placeholder="เพิ่มแท็ก (พิมพ์ข้อความที่ต้องการ แล้วกด Enter เพื่อเพิ่ม)"
        />
      )}
    />
  )
}

export default TagsInputForm
